<template>
    <div class="body" id="joinUp">
        <div class="head">
            <div class="head-title">校园安防数据大屏</div>
            <div class="nowTime">{{nowTime}}</div>
        </div>
        <div class="box">
            <div class="box-l">
                <div class="box-lt">
                    <div class="box-ltl box-img">
                        <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                        <div class="screen-title">今日学生轨迹分布</div>
                        <div class="build-box">
                            <div v-for="(item,index) in track" :key="index" class="build-div">
                                <span class="white buildName">{{item.name}}</span>
                                <span class="cnt">{{item.cnt}}</span>
                                <span class="text">学生人数</span>
                            </div>
                        </div>
                    </div>
                    <div class="box-ltr">
                        <div class="box-ltr1 box-img">
                            <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                            <div class="screen-title">今日学生勤检报告
                                <div class="top-btn">
                                    <p :class="tabActive==1?'active':''" @click="tabActiveClick(1)">今日勤检</p>
                                    <p :class="tabActive==2?'active':''" @click="tabActiveClick(2)">今日晨检</p>
                                </div>
                            </div>
                            <div class="box-ltr1-pie">
                                <div>
                                    <div id="myEcharts1" class="usePie"></div>
                                    <div class="purple">实际出勤学生</div>
                                </div>
                                <div>
                                    <div id="myEcharts2" class="usePie"></div>
                                    <div class="orange">出勤率</div>
                                </div>
                                <div>
                                    <div id="myEcharts3" class="usePie"></div>
                                    <div class="blue">应到人数</div>
                                </div>
                                <div>
                                    <div id="myEcharts4" class="usePie"></div>
                                    <div class="cyan">走读人数</div>
                                </div>
                                <div>
                                    <div id="myEcharts5" class="usePie"></div>
                                    <div class="yellow">请假人数</div>
                                </div>
                            </div>

                        </div>
                        <div class="box-ltr2 box-img">
                            <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                            <div class="screen-title">近7日勤检学生分布</div>
                            <div id="myEcharts8" class="echartBar statics"></div>
                        </div>
                    </div>
                </div>
                <div class="box-lb box-img">
                    <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                    <div class="echart">
                        <div class="screen-title">今日班级勤检分布</div>
                        <div id="myEcharts9" class="echartBar statics"></div>
                    </div>
                </div>
            </div>
            <div class="box-r">
                <div class="box-rt box-img">
                    <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                    <div class="screen-title">安防指数</div>
                    <div class="box-use">
                        <div>
                            <div id="myEcharts6" class="usePie"></div>
                            <div>校外访客</div>
                        </div>
                        <div>
                            <div id="myEcharts7" class="usePie"></div>
                            <div>消防烟感</div>
                        </div>
                        <div>
                            <div id="myEcharts10" class="usePie"></div>
                            <div>家长签到</div>
                        </div>
                        <div>
                            <div id="myEcharts11" class="usePie"></div>
                            <div>一键报警</div>
                        </div>
                        <div>
                            <div id="myEcharts12" class="usePie"></div>
                            <div>周界警示</div>
                        </div>
                        <div>
                            <div id="myEcharts13" class="usePie"></div>
                            <div>宿管巡查</div>
                        </div>
                    </div>
                </div>
                <div class="box-rb box-img">
                    <img src="../../assets/imgs/smartLinkBigScreen/img_kuang (1).png" alt="Background">
                    <div class="table">
                        <div class="screen-title">值周值日</div>
                        <div class="phone-box">
                            <div>
                                <span>街道电话:</span>
                                <span class="white">65****33</span>
                            </div>
                            <div>
                                <span>负责人:某某</span>
                                <span class="white">133****3068</span>
                            </div>
                            <div>
                                <span>运输电话:</span>
                                <span class="white">69****68</span>
                            </div>
                            <div>
                                <span>联络人:某某</span>
                                <span class="white">130****0000</span>
                            </div>
                        </div>
                        <div class="duty-box">
                            <div>
                                <p>日班</p>
                                <p class="white">08:00 - 18:00</p>
                            </div>
                            <div>
                                <p>主班:
                                    <span class="white">某某（科员）</span>
                                </p>
                                <p>
                                    副班:
                                    <span class="white">某某（党工委书记）</span>
                                </p>
                            </div>
                            <div>
                                <p>夜班</p>
                                <p class="white">18:00 - 08:00</p>
                            </div>
                            <div>
                                <p>主班:
                                    <span class="white">某某（科员）</span>
                                </p>
                                <p>
                                    副班:
                                    <span class="white">某某（党工委书记）</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "securityScreen",
        data() {
            return {
                query: {
                    schoolId: '',
                    openid: 'abc',
                    // dailyCheckReportId: 1035766249062400,
                    dailyCheckReportId: 3942281453535232
                },
                realTime: [],
                screenDatas: {},
                myCharts1: null,
                myCharts2: null,
                myCharts3: null,
                myCharts4: null,
                myCharts5: null,
                myCharts6: null,
                myCharts7: null,
                myCharts9: null,
                myCharts10: null,
                myCharts11: null,
                myCharts12: null,
                myCharts13: null,
                nowTime: '',

                myStudent3: {},
                track: [],
                tabActive: 1,
            }
        },
        created() {
            this.query.schoolId = this.$route.query.schoolId
            window.onresize = () => {
                this.myCharts1.resize();
                this.myCharts2.resize();
                this.myCharts3.resize();
                this.myCharts4.resize();
                this.myCharts5.resize();

                this.myCharts8.resize();

                this.myCharts9.resize();
                this.myCharts6.resize();
                this.myCharts7.resize();
                this.myCharts10.resize();
                this.myCharts11.resize();
                this.myCharts12.resize();
                this.myCharts13.resize();
            };
            this.nowTimes()
        },
        mounted() {
            this.funAll()
        },

        methods: {
            timeFormate(timeStamp) {
                let year = new Date(timeStamp).getFullYear();
                let month = new Date(timeStamp).getMonth() + 1 < 10 ? "0" + (new Date(timeStamp).getMonth() + 1) : new Date(timeStamp).getMonth() + 1;
                let date = new Date(timeStamp).getDate() < 10 ? "0" + new Date(timeStamp).getDate() : new Date(timeStamp).getDate();
                let hh = new Date(timeStamp).getHours() < 10 ? "0" + new Date(timeStamp).getHours() : new Date(timeStamp).getHours();
                let mm = new Date(timeStamp).getMinutes() < 10 ? "0" + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes();
                let ss = new Date(timeStamp).getSeconds() < 10 ? "0" + new Date(timeStamp).getSeconds() : new Date(timeStamp).getSeconds();
                this.nowTime = year + "-" + month + "-" + date + ' ' + hh + ":" + mm + ':' + ss

            },
            nowTimes() {
                this.timeFormate(new Date());
                setInterval(this.nowTimes, 1000);
                this.clear()
            },
            clear() {
                clearInterval(this.nowTimes)
                this.nowTimes = null;
            },
            tabActiveClick(tabActive){
                this.tabActive=tabActive
                this.funAll()
            },
            funAll() {
                this.getPieChart(); //基本情况
            },
            // 基本情况
            getPieChart() {
                let url = "/zuhu1/api-dashboard/alarm/dashboard"
                this.$api.post(url, this.query, response => {
                    if (response.data.result == "success") {
                        let datas = response.data.data
                        this.screenDatas = datas || {}
                        let myStudent3 = datas.myStudent3 || {}
                        this.myStudent3 = myStudent3
                        this.track = datas.track || []
                        this.statistics1()
                        this.statistics2()
                        this.statistics3()
                        this.statistics4()
                        this.statistics5()


                        this.statistics6()
                        this.statistics7()


                        let classInfoList = myStudent3.classInfoList || []
                        let x = [], y1 = [], y2 = [], y3 = []
                        classInfoList.map(item => {
                            x.push(item.name)
                            y1.push(0)
                            y2.push(item.leaveEarly)
                            y3.push(item.arrived)
                        })
                        this.statistics9(x, y1, y2, y3)

                        let signPie = this.screenDatas.securityIndex.signPie || 0
                        this.statistics10(signPie)
                        this.statistics11()
                        this.statistics12()
                        this.statistics13()

                        let trend7 = datas.trend7 || []
                        let tredx = [], tredy1 = [], tredy2 = [], tredy3 = []
                        trend7.map(item => {
                            tredx.push(item.date)
                            tredy1.push(item.myStudent3.arrived || 0)
                            tredy2.push(item.myStudent3.leaveNumTotal || 0)
                            tredy3.push(item.myStudent3.dayStudentNumTotal || 0)
                        })
                        this.statistics8(tredx, tredy1, tredy2, tredy3)


                    }
                })
            },
            statistics1() {
                let arrived = this.myStudent3.arrived || 0
                this.myCharts1 = this.$echarts.init(document.getElementById('myEcharts1'))
                // 绘制图表
                this.myCharts1.setOption({
                    color: ['#A859FF', '#0B1B34'],
                    title: {
                        text: arrived,
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 24,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: arrived},
                            ],
                        }
                    ]
                })
            },
            statistics2() {
                let arrived = this.myStudent3.arrived || 0
                let studentCount = this.myStudent3.studentCount || 0
                let rate = (arrived / studentCount * 100) || 0
                this.myCharts2 = this.$echarts.init(document.getElementById('myEcharts2'))
                // 绘制图表
                this.myCharts2.setOption({
                    color: ['#FF9744', '#0B1B34'],
                    title: {
                        text: rate,
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 24,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: rate},
                            ],
                        }
                    ]
                })
            },
            statistics3() {
                let studentCount = this.myStudent3.studentCount || 0
                this.myCharts3 = this.$echarts.init(document.getElementById('myEcharts3'))
                // 绘制图表
                this.myCharts3.setOption({
                    color: ['#34ABFF', '#0B1B34'],
                    title: {
                        text: studentCount,
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 24,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: studentCount},
                            ],
                        }
                    ]
                })
            },
            statistics4() {
                let dayStudentNumTotal = this.myStudent3.dayStudentNumTotal || 0
                this.myCharts4 = this.$echarts.init(document.getElementById('myEcharts4'))
                // 绘制图表
                this.myCharts4.setOption({
                    color: ['#2DEDC8', '#0B1B34'],
                    title: {
                        text: dayStudentNumTotal,
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 24,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: dayStudentNumTotal},
                            ],
                        }
                    ]
                })
            },
            statistics5() {
                let lateNumTotal = this.myStudent3.lateNumTotal || 0
                this.myCharts5 = this.$echarts.init(document.getElementById('myEcharts5'))
                // 绘制图表
                this.myCharts5.setOption({
                    color: ['#DFC825', '#0B1B34'],
                    title: {
                        text: lateNumTotal,
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 24,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: lateNumTotal},
                            ],
                        }
                    ]
                })
            },

            statistics6() {
                this.myCharts6 = this.$echarts.init(document.getElementById('myEcharts6'))
                // 绘制图表
                this.myCharts6.setOption({
                    color: ['#546792', '#0B1B34'],
                    title: {
                        text: '0',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: 0},
                            ],
                        }
                    ]
                })
            },

            statistics7() {
                this.myCharts7 = this.$echarts.init(document.getElementById('myEcharts7'))
                // 绘制图表
                this.myCharts7.setOption({
                    color: ['#CF8294', '#0B1B34'],
                    title: {
                        text: '0',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: 0},
                            ],
                        }
                    ]
                })
            },

            statistics10(signPie) {
                this.myCharts10 = this.$echarts.init(document.getElementById('myEcharts10'))
                // 绘制图表
                this.myCharts10.setOption({
                    color: ['#32AABE', '#0B1B34'],
                    title: {
                        text: signPie,
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: signPie},
                            ],
                        }
                    ]
                })
            },
            statistics11() {
                this.myCharts11 = this.$echarts.init(document.getElementById('myEcharts11'))
                // 绘制图表
                this.myCharts11.setOption({
                    color: ['#52AC93', '#0B1B34'],
                    title: {
                        text: '0',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: 0},
                            ],
                        }
                    ]
                })
            },
            statistics12() {
                this.myCharts12 = this.$echarts.init(document.getElementById('myEcharts12'))
                // 绘制图表
                this.myCharts12.setOption({
                    color: ['#786851', '#0B1B34'],
                    title: {
                        text: '0',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: 0},
                            ],
                        }
                    ]
                })
            },
            statistics13() {
                this.myCharts13 = this.$echarts.init(document.getElementById('myEcharts13'))
                // 绘制图表
                this.myCharts13.setOption({
                    color: ['#B3AC68', '#0B1B34'],
                    title: {
                        text: '0',
                        left: 'center',
                        top: 'center',
                        textStyle: {
                            color: '#fff',
                            fontSize: 20,
                            textAlign: 'center'
                        },
                    },
                    series: [
                        {
                            type: 'pie',
                            radius: ['65%', '85%'],
                            label: {
                                show: false,
                            },
                            data: [
                                {value: 0},
                            ],
                        }
                    ]
                })
            },

            statistics9(x, y1, y2, y3) {
                this.myCharts9 = this.$echarts.init(document.getElementById('myEcharts9'))
                // 绘制图表
                this.myCharts9.setOption({
                    color: ['#42FFE3', '#F5CE03', '#CC4450'],
                    legend: {
                        data: ['迟到', '请假', '实际出勤'],
                        textStyle: {
                            color: '#ffffff',
                        },
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            animation: false
                        }
                    },
                    grid: {
                        top: '20%',
                        left: '8%',
                        right: '5%',
                        bottom: '15%'
                    },
                    xAxis: {
                        type: 'category',
                        data: x,
                        axisLabel: {
                            color: '#ffffff',
                            fontSize: 14
                        },

                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            color: '#ffffff',
                            fontSize: 14
                        },
                    },
                    series: [
                        {
                            name: '迟到',
                            data: y1,
                            type: 'bar',
                            stack: 'total',
                        },
                        {
                            name: '请假',
                            data: y2,
                            type: 'bar',
                            stack: 'total',
                        },
                        {
                            name: '实际出勤',
                            data: y3,
                            type: 'bar',
                            stack: 'total',
                        },
                    ]
                })
            },

            statistics8(tredx, tredy1, tredy2, tredy3) {
                this.myCharts8 = this.$echarts.init(document.getElementById('myEcharts8'))
                // 绘制图表
                this.myCharts8.setOption({
                    color: ['#FD397B', '#F9EE44', '#67D9BF'],
                    legend: {
                        data: ['实际出勤学生数', '请假学生数', '走读学生数'],
                        textStyle: {
                            color: '#ffffff',
                        },
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            animation: false
                        }
                    },
                    grid: {
                        top: '12%',
                        left: '5%',
                        right: '5%',
                        bottom: '20%'
                    },
                    xAxis: {
                        type: 'category',
                        data: tredx,
                        axisLabel: {
                            color: '#b9bfd0',
                            fontSize: 14
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#bbb',
                            }

                        },
                        axisTick: {
                            color: '#b9bfd0',
                            length: 5
                        },
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            color: '#A2A8B9',
                            fontSize: 14
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#bbb',
                            }
                        },

                    },
                    series: [
                        {
                            name: '实际出勤学生数',
                            data: tredy1,
                            type: 'line',
                            areaStyle: {
                                color: '#FD397B',
                                opacity: 0.2,
                            },
                            smooth: true,
                        },
                        {
                            name: '请假学生数',
                            data: tredy2,
                            type: 'line',
                            smooth: true,
                            areaStyle: {
                                color: '#F9EE44',
                                opacity: 0.2,
                            },

                        },
                        {
                            name: '走读学生数',
                            data: tredy3,
                            type: 'line',
                            smooth: true,
                            areaStyle: {
                                color: '#67D9BF',
                                opacity: 0.2,
                            },

                        }
                    ]
                })
            },


        }
    }
</script>

<style scoped>
    .body {
        width: 100%;
        /*height: 1080px;*/
        height: 100%;
        background: rgb(3, 17, 51);
        overflow: hidden;
        background: url("../../assets/imgs/smartLinkBigScreen/bg.jpg") no-repeat center 0;
    }

    .head {
        height: 120px;
        color: white;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-size: 38px;
        position: relative;
        background: url("../../assets/imgs/smartLinkBigScreen/topbg.png") no-repeat center 0;
        box-sizing: border-box;
    }

    .head-title {
        background: -webkit-linear-gradient(#4AF3F3, #179DF5);
        -webkit-background-clip: text;
        color: transparent;
        font-weight: bold;
    }

    .box {
        display: flex;
        /*height: 960px;*/
        height: calc(100% - 100px);
        /*margin-top: -20px;*/
    }

    .box > div {
        padding: 10px 0 0;
    }

    .box > div > div {
        width: 98%;
        margin: 0 auto 20px;
    }

    .box-l {
        flex: 1;
    }

    .box-lt {
        display: flex;
        justify-content: space-between;
    }

    .box-ltl {
        position: relative;
        width: 30%;
        height: 100%;
    }

    .box-ltr {
        width: 69%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .box-ltr > div {
        width: 100%;
        height: 49%;
        position: relative;
    }

    .box-ltr1-pie {
        display: flex;
        height: calc(100% - 70px);
        font-size: 18px;
    }

    .box-ltr1-pie > div {
        flex: 1;
        text-align: center;
    }

    .box-r {
        width: 28%;
    }

    .box-c {
        flex: 1;
        padding: 30px 0 0 0 !important;
    }

    .box-c > div {
        width: 96% !important;
    }

    .screen-title {
        color: #b3cef1 !important;
        /*font-weight: bold;*/
        font-size: 20px;
        padding: 20px 30px 10px;
        position: relative;
        z-index: 10;
    }

    .box-img img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    .box-lt {
        height: 60%;
    }

    .box-lb {
        height: 35%;
        position: relative;
    }

    .table {
        height: 100%;
        display: flex;
        flex-direction: column;
    }


    .table-title p {
        width: 25%;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }


    .table-box > div {
        display: flex;
        color: rgb(229, 238, 227);
        justify-content: space-between;
    }

    .table-box > div:nth-child(odd) {
        background: rgb(17, 33, 62);
    }

    .table-box > div > p {
        width: 25%;
        text-align: center;
        height: 40px;
        line-height: 40px;
        white-space: nowrap;
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .statics {
        width: 100%;
        /*height: 150px*/
        height: 100%;
    }


    .box-rt {
        height: calc(50%);
        position: relative;
    }

    .box-rb {
        height: calc(45%);
        position: relative;
    }

    .box-use {
        position: relative;
        z-index: 10;
        height: calc(100% - 66px);
    }

    .box-use > div {
        display: inline-block;
        height: 48%;
        width: 33%;
        color: white;
        text-align: center;
    }

    .usePie {
        width: 100%;
        height: calc(100% - 30px);
    }

    .echart {
        width: 100%;
        height: 100%;
    }

    .echartBar {
        height: calc(100% - 56px);
    }

    .buildBtn {
        color: white;
        position: absolute;
        font-size: 12px;
        text-align: center;
    }

    .buildBtn img {
        position: relative !important;
        width: 10px;
        height: 10px;
        text-align: center;
    }

    .nowTime {
        color: #69E7EE;
        position: absolute;
        right: 20px;
        top: 14px;
        font-size: 26px;
        display: inline-block;
    }

    .purple {
        color: #A859FF;
    }

    .orange {
        color: #FF9744;
    }

    .blue {
        color: #34ABFF;
    }

    .cyan {
        color: #2DEDC8;
    }

    .yellow {
        color: #DFC825;
    }

    .phone-box {
        color: #0188CF;
        display: flex;
        flex-wrap: wrap;
    }

    .phone-box > div {
        width: 50%;
        text-align: center;
    }

    .white {
        color: white;
        padding: 0 10px;
    }

    .duty-box {
        display: flex;
        flex-wrap: wrap;
    }

    .duty-box > div {
        width: 46%;
        margin: 10px 2%;
        background: #051A47;
        color: #70B7BB;
        padding: 20px 5px 20px 20px;
        box-sizing: border-box;
    }

    .duty-box p {
        padding: 5px 0;
        box-sizing: border-box;
    }

    .build-box {
        height: calc(100% - 80px);
        overflow-y: auto;
        position: relative;
        z-index: 10;
    }

    .build-box::-webkit-scrollbar {
        width: 4px;
    }

    .build-box::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        opacity: 0.2;
        background: rgba(120, 229, 250, 1);
    }

    .build-box::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: rgba(120, 229, 250, 0.6);
    }

    .build-div {
        text-align: center;
        padding: 5px 0;
    }

    .build-div span {
        display: inline-block;
    }

    .buildName {
        font-size: 18px;
        /*padding: 0 20px;*/
        width: 140px;
    }

    .cnt {
        color: #A859FF;
        font-weight: bold;
        font-size: 32px;
        padding: 0 5px;
        width: 50px;
    }

    .text {
        color: #5C84DE;
    }

    .top-btn {
        font-size: 16px;
        color: #0085CC;
        display: flex;
        position: absolute;
        top: 22px;
        right: 30px;
    }

    .top-btn p {
        padding: 0 5px;
        cursor: pointer;
    }

    .active {
        color: #56C7EA;
    }
</style>


